import { render, staticRenderFns } from "./DC-dashboard-dyn.vue?vue&type=template&id=d67c2f76"
import script from "./DC-dashboard-dyn.vue?vue&type=script&lang=js"
export * from "./DC-dashboard-dyn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports